import { Organization } from "@gettactic/api";

export type MobileAppAction =
  | "login"
  | "logout"
  | "openSettings"
  | "openInfo"
  | "printBadge"
  | "openPrinterSetup"
  | "openDisplaySettings"
  | "badgeThemes"
  | "stationInfo";

/** A printed-badge theme the kiosk can render; published to the stations app for its selector. */
export type BadgeThemeSummary = {
  id: string;
  name: string;
  description: string;
};

/** The station a kiosk runs as; the stations app tags its error reports with it. */
export type StationInfo = {
  stationId: string;
  stationName: string;
  organizationSlug: string | null;
};

// biome-ignore lint/style/noVar: <explanation>
declare var window: Window;

type WebViewWindow = Window & {
  ReactNativeWebView: { postMessage: (data: unknown) => void };
};

export type MobileActionMap = {
  login: { token: string };
  logout: undefined;
  openSettings: { tab?: "account" };
  openInfo: {
    organizations: Organization[];
    organization: Organization | null;
  };
  printBadge: { imageBase64: string };
  openPrinterSetup: undefined;
  openDisplaySettings: undefined;
  badgeThemes: { themes: BadgeThemeSummary[] };
  stationInfo: { station: StationInfo | null };
};

export type ActionPayload<T extends MobileAppAction> = MobileActionMap[T];

export function invokeMobileAppAction<T extends MobileAppAction>(
  action: T,
  data: ActionPayload<T>
) {
  const message = JSON.stringify({ action, data });

  if (
    //@ts-ignore
    typeof window !== "undefined" &&
    //@ts-ignore
    "ReactNativeWebView" in window &&
    //@ts-ignore
    typeof (window as WebViewWindow).ReactNativeWebView.postMessage ===
      "function"
  ) {
    //@ts-ignore
    (window as WebViewWindow).ReactNativeWebView.postMessage(message);
  } else {
    console.warn("ReactNativeWebView is not available");
  }
}
